export default __webpack_public_path__ + "static/media/cheatday_2.12c2f959.jpg";